import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: {
  isLoading: Boolean;
  ticketUpdateData: any;
  isError: Boolean;
  ambulanceMessage: string;
  shortlistedProviders: any[];
  selectedProviderId: string | null;
} = {
  isLoading: false,
  shortlistedProviders: [],
  selectedProviderId: null,
  ticketUpdateData: {
    ticketId:null,
    currentMedicalStatusResponse: {
        isItEmergency: "Yes",
        isAmbulanceRequired: "Yes",
        isDoctorConsultationRequired: "Yes",
        isPatientConscious: "Yes",
        mobilityStatus: "",
        currentCondition: [""],
        otherDescription: "",
        timeOfSymptomsOnset: "",
      },
  },
  isError: false,
  ambulanceMessage: "",
};

const ticketUpdateSlice = createSlice({
  name: "ticketUpdate",
  initialState,
  reducers: {
    ticketUpdateStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    ticketConfirmPoc: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.isError = false;
      state.ticketUpdateData.confirmedPoc = action.payload;
    },
    ticketUpdateCurrentMedicalStatusSuccess: (state, action: PayloadAction<any>) => {
      // console.log('action:', action);
      state.isLoading = false;
      state.isError = false;
      let payload=action.payload
      
      state.ticketUpdateData.currentMedicalStatusResponse = {...state.ticketUpdateData.currentMedicalStatusResponse,...payload};
    },
    ticketIdStatusSuccess: (state, action: PayloadAction<any>) => {
      // console.log('action:', action);
      state.isLoading = false;
      state.isError = false;       
      state.ticketUpdateData.ticketId =action.payload;
    },

    ticketUpdateDefaultValue:(state,action: PayloadAction<any>)=>{
      state.isLoading = false;
      state.isError = false;
      state.shortlistedProviders = [];
      state.selectedProviderId = null;
      state.ticketUpdateData={       
        ticketId:action.payload,
        currentMedicalStatusResponse: {
            isItEmergency: "Yes",
            isAmbulanceRequired: "Yes",
            isDoctorConsultationRequired: "Yes",
            isPatientConscious: "Yes",
            mobilityStatus: "",
            currentCondition: [""],
            otherDescription: "",
            timeOfSymptomsOnset: "",
          }
    }
  },

    ticketUpdateStatusSuccess: (state, action: PayloadAction<any>) => {
      // console.log('action:', action);
      state.isLoading = false;
      state.isError = false;
      let payload=action.payload
      
      state.ticketUpdateData = {...state.ticketUpdateData,...payload};
    },
    setAmbulanceMessage: (state, action: PayloadAction<string>) => {
      state.ambulanceMessage = action.payload;
    },
    setShortlistedProviders: (state, action: PayloadAction<any[]>) => {
      state.shortlistedProviders = action.payload;
    },
    setSelectedProviderId: (state, action: PayloadAction<string | null>) => {
      state.selectedProviderId = action.payload;
    },
    ticketUpdateFailure: (state) => {
      state.isLoading = false;
      state.isError = true;
      state.ticketUpdateData = null
    },
    ticketUpdateClear: (state) => {
      state.isLoading = false;
      state.isError = true;
      state.ticketUpdateData = null
    },
    
  },
});

export const { ticketUpdateStart,ticketIdStatusSuccess,ticketUpdateDefaultValue, ticketUpdateCurrentMedicalStatusSuccess,ticketUpdateStatusSuccess, ticketUpdateClear,ticketUpdateFailure,ticketConfirmPoc,setAmbulanceMessage,setShortlistedProviders,setSelectedProviderId } =
ticketUpdateSlice.actions;

export default ticketUpdateSlice.reducer;
